import type { WatchQueryFetchPolicy } from "@apollo/client";

interface FetchPolicyConfig {
  fetchPolicy: WatchQueryFetchPolicy;
  nextFetchPolicy?: WatchQueryFetchPolicy;
}

export const CACHE_AND_NETWORK_THEN_CACHE_FIRST: FetchPolicyConfig = {
  fetchPolicy: "cache-and-network",
  nextFetchPolicy: "cache-first",
};

/** Apollo v4 may report loading=true during cache-and-network background refetches. */
export const isInitialApolloLoad = (
  loading: boolean,
  hasCachedData: boolean
): boolean => loading && !hasCachedData;
